exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3TbBo{padding:7px 4px 3px;font-size:14px;white-space:nowrap;overflow:hidden;-o-text-overflow:ellipsis;text-overflow:ellipsis}._24W79{padding:0!important}", ""]);

// exports
exports.locals = {
	"field": "_3TbBo",
	"tdClear": "_24W79"
};